export type ColumnKey = string; // step/stage id OR "_unassigned"

// A board column descriptor — campaign steps and pipeline stages both map
// onto this shape; the owning page derives label/title/subtitle strings.
export interface BoardColumn {
  key: ColumnKey;
  label: string;
  title: string;
  subtitle?: string;
  description?: string;
}

export function cardDraggableId(column: ColumnKey, contactId: string) {
  return `card::${column}::${contactId}`;
}

export function parseCardId(
  id: string,
): { column: ColumnKey; contactId: string } | null {
  if (!id.startsWith("card::")) return null;
  const rest = id.slice(6);
  const idx = rest.indexOf("::");
  if (idx === -1) return null;
  return { column: rest.slice(0, idx), contactId: rest.slice(idx + 2) };
}

export function columnDroppableId(column: ColumnKey) {
  return `col::${column}`;
}

export function parseColumnId(id: string): ColumnKey | null {
  return id.startsWith("col::") ? id.slice(5) : null;
}

export function columnLabel(
  cols: BoardColumn[],
  key: ColumnKey | null,
): string {
  if (!key) return "—";
  const c = cols.find((x) => x.key === key);
  if (!c) return key;
  return c.label && c.label !== c.title ? `${c.label} · ${c.title}` : c.title;
}

export function columnOf(
  snap: { columns: Record<string, Array<{ contact_id: string }>> } | undefined,
  card: { contact_id: string } | null,
): ColumnKey | null {
  if (!snap || !card) return null;
  for (const [colKey, list] of Object.entries(snap.columns)) {
    if (list.some((c) => c.contact_id === card.contact_id)) return colKey;
  }
  return null;
}
